import React from "react";
import { noop } from "../../utils";
import styles from "./image.css";
import { fileService } from "../../services/files/fileService";

interface Props {
  alt?: string;
  className?: string;
  fallbackSrc?: string;
  fallbackComponent?: JSX.Element;
  src?: string;
}

interface State {
  currentSrc?: string;
  failed: boolean;
  loaded: boolean;
}

export class ImageComponent extends React.Component<Props, State> {
  testImage?: HTMLImageElement;

  constructor(props: Props) {
    super(props);
    this.state = {
      currentSrc: props.fallbackSrc,
      failed: false,
      loaded: false
    };
  }

  private updateImageSrc = (src: string | undefined) => {
    if (src) {
      fileService.getDataUrl(src)
        .then((dataUrl) => this.setState({
          currentSrc: dataUrl,
          loaded: true,
          failed: false
        }))
        .catch(() => this.setState({
          currentSrc: this.props.fallbackSrc,
          failed: true,
          loaded: false
        }));
    }
  };

  componentDidMount() {
    this.updateImageSrc(this.props.src);
  }

  shouldComponentUpdate(nextProps: Props): boolean {
    if (this.props.src !== nextProps.src) {
      if (nextProps.src === undefined) {
        this.setState({ currentSrc: undefined });
        return true;
      } else {
        this.updateImageSrc(nextProps.src);
        return false;
      }
    }

    return true;
  }

  componentWillUnmount() {
    if (this.testImage) {
      this.testImage.onload = noop;
      this.testImage.onerror = noop;
    }
  }

  render() {
    if (this.state.currentSrc) {
      return (
        <div
          className={[styles.image, this.props.className].join(" ")}
          style={{ backgroundImage: `url(${this.state.currentSrc})` }}
        />
      );
    } else if (this.props.fallbackComponent) {
      return this.props.fallbackComponent;
    } else {
      return (
        <div
          className={styles.image}
          style={{
            backgroundImage: `url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7)`
          }}
        />
      );
    }
  }
}
